export const editorTheme = {
  accent: '#7300e6',
  accentHover: '#5a00b8',
  accentSoft: '#f3ebfe',
  text: '#25232e',
  textMuted: '#6b6878',
  border: '#e3e1ea',
  surface: '#ffffff',
  surfaceMuted: '#f6f5f9',
  workspace: '#ebeaf0',
  rail: '#1d1b24',
  railActive: '#2f2c3a',
  railText: '#b7b4c4',
  success: '#2f7a4f',
  successSoft: '#eaf6ef',
  warning: '#9a5b00',
  warningSoft: '#fff4e0',
  danger: '#b42318',
  dangerSoft: '#fdecea',
};

export const HEADER_HEIGHT = 56;
export const TOOLBAR_HEIGHT = 48;
